import {
  BaseApiService,
} from '@/services/base-api-service';
import {
  RefreshTokenRequest,
  RefreshTokenResponse,
} from '@/services/types/auth-api-service';

class AuthApiService extends BaseApiService {
  constructor() {
    super(`${__config.url.api}/auth`, true);
  }

  public async refreshToken(params: RefreshTokenRequest): Promise<RefreshTokenResponse> {
    return this.http.post('/access-token', params);
  }
}

export const authApiService = new AuthApiService();
